<template>
  <v-card>
    <v-card-title>
      {{ $t('staging.uploadForm.title') }}
    </v-card-title>

    <v-card-subtitle class="mt-1" v-if="loading">
      {{ $t('staging.uploadForm.subtitle.loading') }}
    </v-card-subtitle>
    <v-card-subtitle class="mt-1" v-else>
      {{ useDnD ? $t('staging.uploadForm.subtitle.dnd') : $t('staging.uploadForm.subtitle.select') }}
    </v-card-subtitle>

    <v-card-text v-if="!loading">
      <p><a href="#" @click.prevent="onDownloadTemplate">{{ $t('staging.uploadForm.example') }}</a></p>

      <v-card v-if="useDnD" flat class="droparea"
        @drop.prevent="onDrop($event)"
        @dragover.prevent="dragover = true"
        @dragenter.prevent="dragover = true"
        @dragleave.prevent="dragover = false"
        :class="{ 'grey lighten-2': dragover }">
        <v-card-text class="d-flex flex-column align-center justify-center" style="min-height: 200px;">
          <v-icon size="80" class="mb-4">mdi-file-excel</v-icon>
          <p class="text-subtitle-1 mb-0 text-center">{{ $t('staging.addForm.drop_files_here') }}</p>
        </v-card-text>
        <v-card-text>
          <v-virtual-scroll
            v-if="droppedFiles.length > 0"
            :items="droppedFiles"
            height="150"
            item-height="50"
          >
            <template v-slot:default="{ item }">
              <v-list-item :key="item.name">
                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn @click.stop="removeFile(item)" icon>
                    <v-icon>mdi-close-circle</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
            </template>
          </v-virtual-scroll>
        </v-card-text>
        <v-card-text class="d-flex">
          <v-spacer></v-spacer>
          <template v-if="droppedFiles.length">
            {{ droppedFiles.length + ' ' + $t('staging.addForm.num_files') }}
          </template>
        </v-card-text>
      </v-card>

      <v-file-input v-else
        v-model="files"
        multiple
        :label="$t('staging.uploadForm.label')"
        accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      />

      <v-switch v-model="revoke" :label="$t('staging.uploadForm.revoke')"/>
      <v-switch v-model="commit" :label="$t('staging.uploadForm.commit')"/>
    </v-card-text>

    <v-card-actions v-if="loading">
      <v-progress-linear color="secondary" indeterminate/>
    </v-card-actions>
    <v-card-actions v-else>
      <v-btn text @click="switchDnDMode">
        {{ useDnD ? $t('staging.uploadForm.switchToSelect') : $t('staging.uploadForm.switchToDnD') }}
      </v-btn>
      <v-spacer/>
      <v-btn text color="secondary" @click="onSave" :disabled="useDnD ? !droppedFiles.length : !files.length">
        {{ $t('staging.uploadForm.upload') }}
      </v-btn>
      <v-btn text color="secondary" @click="$emit('cancel')">{{ $t('staging.uploadForm.cancel') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import downloadFile from "@/utils/downloadFile";

export default {
  name: "AddRightExcelForm",

  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      useDnD: false,
      dragover: false,
      droppedFiles: [],
      files: [],
      revoke: false,
      commit: true,
    }
  },

  methods: {
    onSave() {
      const files = this.useDnD ? this.droppedFiles : this.files;
      this.$emit('save', { files, revoke: this.revoke, commit: this.commit });
    },

    removeFile(item) {
      const index = this.droppedFiles.findIndex(e => e === item);
      if (index > -1) this.droppedFiles.splice(index, 1);
    },

    switchDnDMode() {
      if (this.useDnD) {
        this.droppedFiles = [];
      } else {
        this.files = [];
      }
      this.useDnD = !this.useDnD;
    },

    onDrop(e) {
      this.dragover = false;
      try {
        const files = e.dataTransfer.files;
        const validRe = /.xls(x?)$/i;
        files.forEach(element => {
          if (validRe.test(element.name)) {
            this.droppedFiles.push(element);
          }
        });
      } catch (error) {
        //
      }
    },

    onDownloadTemplate() {
      this.$store.dispatch('app/getXLSXTemplateUrl')
        .then((data) => {
          const lang = ((s) => s.replace(s[0], s[0].toUpperCase()))(this.$i18n.locale);
          const name = data.docname[lang];
          const uri = data.docuri[lang];
          const type = data.doctype;
          this.$store.dispatch('app/downloadPrivateDocument', { uri, type })
            .then((uri) => downloadFile(name, uri));
        });
    },
  }
}
</script>

<style scoped>
.droparea {
  background-color: var(--color-surface-container-high) !important;
}
</style>
